(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("ManagingTokensViewModel", managingTokensViewModelFactory);

  /** @ngInject */
  function managingTokensViewModelFactory() {
    function ManagingTokensViewModel() {
      this.customError = "";
      this.hasError = false;
      this.isUserSelected = false;
      this.selectedUser = "";
      this.tokenList = [];
    }

    ManagingTokensViewModel.prototype.destroy = function() {};

    ManagingTokensViewModel.prototype.refresh = function(data) {
      this.tokenList = data;
    };

    return ManagingTokensViewModel;
  }
})();
